<script setup lang="ts">
import type { KbdTone } from './kbd-types'

withDefaults(
  defineProps<{
    /** Visual weight: `neutral` (default, on an ordinary surface) · `on-accent` (on a filled accent key). */
    tone?: KbdTone
  }>(),
  {
    tone: 'neutral',
  },
)

const TONE_CLASSES: Record<KbdTone, string> = {
  neutral: 'bg-bg-primary text-text-tertiary',
  'on-glass': 'bg-transparent text-text-tertiary',
  'on-accent': 'app-kbd-on-accent bg-transparent text-text-on-accent',
}
</script>

<template>
  <kbd :class="['app-kbd px-4 py-1 font-sans text-caption-emphasized', TONE_CLASSES[tone]]">
    <slot />
  </kbd>
</template>

<style>
.app-kbd {
  --app-kbd-edge: var(--color-border-strong);
  border-radius: var(--radius-kbd);
  box-shadow:
    inset 0 0 0 calc(var(--spacing-1) / 2) var(--app-kbd-edge),
    0 calc(var(--spacing-1) / 2) 0 var(--app-kbd-edge);
}
.app-kbd-on-accent {
  --app-kbd-edge: color-mix(in oklab, var(--color-text-on-accent) 40%, transparent);
}
</style>
